// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_mRlOW {
  width: 100% !important;
  overflow: hidden !important;
}

.cardArea_hRhix {
}

.cardAreaBad_verWK {
  background-color: #ffebed !important;
}

.cardContent_g_vuB {
  overflow-y: auto; /* Enable vertical scrolling */
}

.hidden_Tvdti {
  display: none !important;
}

.embedded_bSL8T {
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/factoryCycleTimeMonitoring/FactoryCycleTimeMonitoring.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;AACA;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".card {\n  width: 100% !important;\n  overflow: hidden !important;\n}\n\n.cardArea {\n}\n\n.cardAreaBad {\n  background-color: #ffebed !important;\n}\n\n.cardContent {\n  overflow-y: auto; /* Enable vertical scrolling */\n}\n\n.hidden {\n  display: none !important;\n}\n\n.embedded {\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card_mRlOW`,
	"cardArea": `cardArea_hRhix`,
	"cardAreaBad": `cardAreaBad_verWK`,
	"cardContent": `cardContent_g_vuB`,
	"hidden": `hidden_Tvdti`,
	"embedded": `embedded_bSL8T`
};
export default ___CSS_LOADER_EXPORT___;
